import React from 'react';

import classNames from 'classnames';
import SanitizedHTML from 'components/ui/sanitized_html';

import ActionConfirmations from './action_confirmations';
import { AI_HTML_OPTIONS } from 'components/ai/html';
import { InlineTools, getClaimedActionIds } from '../tools/inline';
import { StepCard, liveSteps } from '../tools/inline/step_card';
import { formatMetrics } from '../metrics/helpers';
import { useTranscriptContext } from './context';

import type { Message } from '../types';

interface Props {
  message: Message;
  superseded: boolean;
}

export default function AssistantMessage({ message, superseded }: Props) {
  const { busy, resolveAction, showAdminDetails } = useTranscriptContext();
  const runningSteps = liveSteps(message.steps, message.inlineToolCalls);
  const inlineToolCalls = message.inlineToolCalls || [];
  const claimed = getClaimedActionIds(inlineToolCalls);
  const actions = message.actions?.filter(action => !claimed.includes(action.id));

  return (
    <div className="mb-3">
      <div className={classNames({ 'text-danger': message.error })} style={{ maxWidth: '85%' }}>
        <InlineTools superseded={superseded} toolCalls={inlineToolCalls} />
        {runningSteps && <StepCard steps={runningSteps} />}
        {message.content && (
          <SanitizedHTML
            className={classNames('ai-assistant-prose', {
              'is-streaming': message.isStreaming && !message.status,
            })}
            html={message.content}
            {...AI_HTML_OPTIONS}
          />
        )}
        {actions && actions.length > 0 && (
          <ActionConfirmations actions={actions} disabled={busy} onResolve={resolveAction} />
        )}
        {message.isStreaming && !runningSteps && (message.status || !message.content) && (
          <div className="small mt-1">
            <span className="ai-assistant-thinking">{message.status || 'Thinking'}…</span>
          </div>
        )}
        {showAdminDetails && message.metrics && (
          <div className="text-muted small mt-1">{formatMetrics(message.metrics)}</div>
        )}
      </div>
    </div>
  );
}
